import React from "react";

export default function TextSection({ content, color, size, inView, reference, extra }) {
  var fontSize = ''
  switch (size) {
    case 'xs':
      fontSize = 'text-xs'
      break;

    case 's':
      fontSize = 'text-sm'
      break;

    case 'm':
      fontSize = 'text-lg'
      break;

    case 'l':
      fontSize = 'text-xl'
      break;

    default:
      fontSize = 'text-base'
      break;
  }


  return (
    <p
      className={`${fontSize} ${color} ${extra} ${reference ? 'md:opacity-0' : ''} ${inView ? 'animate' : ''} z-20 relative`}
      dangerouslySetInnerHTML={{ __html: content }}
    >
    </p>
  )
}
